(function () {
  // 👇 Configure the link text for each language 👇
  var LINK_TEXT_PL = 'Rozłóż na wygodne raty';
  var LINK_TEXT_EN = 'Pay in installments';

  function getShippingTranslation(plValue, configBase64, defaultBase64) {
    var mapping = {
      '3-5 tygodni': '3-5 weeks',
      '4 tygodnie': '4 weeks',
      '14 dni': '14 days',
      '6-8 tygodni': '6-8 weeks',
      '8-12 tygodni': '8-12 weeks',
      '2-3 tygodnie': '2-3 weeks',
      '7 dni': '7 days',
      '6 tygodni': '6 weeks',
      '4-6 tygodni': '4-6 weeks'
    };
    
    if (configBase64) {
      try {
        var decoded = atob(configBase64);
        var parts = decoded.split('||');
        parts.forEach(function(part) {
          var subparts = part.split('::');
          if (subparts.length >= 3) {
            var pl = subparts[1].trim();
            var en = subparts[2].trim();
            if (pl && en) {
              if (en === '8-12 weeeks') en = '8-12 weeks';
              mapping[pl] = en;
            }
          }
        });
      } catch (e) {
        console.error('Error decoding shipping config:', e);
      }
    }
    
    if (defaultBase64) {
      try {
        var decodedDefault = atob(defaultBase64).trim();
        if (decodedDefault === '4-6 tygodni') {
          mapping['4-6 tygodni'] = '4-6 weeks';
        }
      } catch (e) {}
    }

    var cleanedPl = plValue.trim();
    return mapping[cleanedPl] || cleanedPl;
  }

  function relocateElements() {
    var price = document.querySelector('.product-price-wrapper');

    // Detect language using a triple-layer check (URL path, HTML lang, and Shopify locale)
    var path = window.location.pathname.toLowerCase();
    var lang = (document.documentElement.lang || (window.Shopify && window.Shopify.locale) || 'pl').toLowerCase();
    var isEn = path.startsWith('/en/') || path === '/en' || path.includes('/en-') || lang.startsWith('en');

    // ----------------------------------------------------
    // 1. Move iCalc Button below the Price Block
    // ----------------------------------------------------
    var btn = document.querySelector('.icalc_btn[data-action="open_ic_modal"]');
    if (btn && price) {
      var activeLinkText = isEn ? LINK_TEXT_EN : LINK_TEXT_PL;
      var label = btn.querySelector('.icalc_btn__label');
      if (label && label.textContent.trim() !== activeLinkText) {
        label.textContent = activeLinkText;
      }
      
      if (btn.parentElement !== price || !btn.classList.contains('icalc_btn--link-mode')) {
        price.appendChild(btn);
        btn.classList.add('icalc_btn--link-mode');
      }
    }

    // ----------------------------------------------------
    // 2. Move sizebox dropdown after size variant picker ("Rozmiar" or "Size") [DISABLED]
    // ----------------------------------------------------
    /*
    var dropdown = document.querySelector('.sizebox__dropdown');
    var sizeOptionGroup = document.querySelector('[option-picker-name="Rozmiar"]') || 
                          document.querySelector('[option-picker-name="Size"]') ||
                          document.querySelector('[option-picker-name="size"]');
                          
    if (dropdown && sizeOptionGroup) {
      if (dropdown.previousElementSibling !== sizeOptionGroup) {
        sizeOptionGroup.insertAdjacentElement('afterend', dropdown);
      }
    }
    */

    // ----------------------------------------------------
    // 3. Move Section Heroes price badge to the right of the Price Block
    // ----------------------------------------------------
    var badge = document.querySelector('[id*="sectionheroes_md_price_badge_"]');
    if (!badge) {
      var badgeInner = document.querySelector('[class*="sh-pb-"]');
      if (badgeInner) {
        badge = badgeInner.closest('.shopify-app-block') || badgeInner;
      }
    }

    if (badge && price) {
      if (badge.parentElement !== price) {
        price.appendChild(badge);
      }
    }

    // ----------------------------------------------------
    // 4. Dynamic Shipping Text Overrides (Multi-Language Support)
    // ----------------------------------------------------
    var shippingEl = document.querySelector('.shipping_time');
    if (shippingEl) {
      var labelEl = shippingEl.querySelector('.shipping_time__label');
      // Determine the active value element based on the parent's class
      var valEl = null;
      if (shippingEl.classList.contains('shipping_time--internal')) {
        valEl = shippingEl.querySelector('.shipping_time__value--internal');
      } else if (shippingEl.classList.contains('shipping_time--external')) {
        valEl = shippingEl.querySelector('.shipping_time__value--external');
      } else if (shippingEl.classList.contains('shipping_time--custom')) {
        valEl = shippingEl.querySelector('.shipping_time__value--custom');
      }
      
      // Fallback selector
      if (!valEl) {
        valEl = shippingEl.querySelector('.shipping_time__value--internal') || 
                shippingEl.querySelector('.shipping_time__value--external') ||
                shippingEl.querySelector('[class*="shipping_time__value"]');
      }

      if (labelEl && valEl) {
        // Read the block class to know if we are displaying internal (24h) or external shipping
        var isInternal = shippingEl.classList.contains('shipping_time--internal');

        if (isInternal) {
          // Ready to ship in 24h (Internal)
          var targetLabel = isEn ? 'Order before 4 PM. ' : 'Zamów do 16:00. ';
          var targetValue = isEn ? 'Shipped today!' : 'Wysyłka jeszcze dziś!';

          if (labelEl.textContent !== targetLabel) {
            labelEl.textContent = targetLabel;
          }
          if (valEl.textContent !== targetValue) {
            valEl.textContent = targetValue;
          }
        } else {
          // Shipped from external vendor
          var targetLabelExternal = isEn ? 'Shipping in: ' : 'Wysyłka w: ';

          if (labelEl.textContent !== targetLabelExternal) {
            labelEl.textContent = targetLabelExternal;
          }

          if (isEn) {
            var wrapper = shippingEl.closest('.shipping_time-wrapper');
            var configBase64 = wrapper ? wrapper.getAttribute('data-shipping-config') : '';
            var defaultBase64 = wrapper ? wrapper.getAttribute('data-shipping-default') : '';
            var currentVal = valEl.textContent.trim();
            var translatedVal = getShippingTranslation(currentVal, configBase64, defaultBase64);
            if (valEl.textContent !== translatedVal) {
              valEl.textContent = translatedVal;
            }
          } else {
            // Restore default text / revert to Polish if language swaps back to Polish
            var currentVal = valEl.textContent.trim();
            if (currentVal === 'Shipped today!' || currentVal === 'Wysyłka jeszcze dziś!') {
              valEl.textContent = '24h';
            } else {
              var enToPl = {
                '3-5 weeks': '3-5 tygodni',
                '4 weeks': '4 tygodnie',
                '14 days': '14 dni',
                '6-8 weeks': '6-8 tygodni',
                '8-12 weeks': '8-12 tygodni',
                '8-12 weeeks': '8-12 tygodni',
                '2-3 weeks': '2-3 tygodnie',
                '7 days': '7 dni',
                '6 weeks': '6 tygodni',
                '4-6 weeks': '4-6 tygodni'
              };
              if (enToPl[currentVal]) {
                valEl.textContent = enToPl[currentVal];
              }
            }
          }
        }
      }
    }
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocateElements);
  } else {
    relocateElements();
  }

  // Observe the entire document body for any dynamic loads or re-renders
  var targetNode = document.body;
  if (targetNode && window.MutationObserver) {
    new MutationObserver(relocateElements).observe(targetNode, { childList: true, subtree: true });
  }
})();
